import { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { api } from "@/lib/api";
import { Heart, Eye, ExternalLink } from "lucide-react";

export default function SocialCommand() {
  const [posts, setPosts] = useState([]);
  const [products, setProducts] = useState({});

  useEffect(() => {
    api.get("/social/feed").then((r) => setPosts(r.data)).catch(() => {});
    api.get("/products").then((r) => {
      const map = {};
      (r.data || []).forEach((p) => { map[p.id] = p; });
      setProducts(map);
    }).catch(() => {});
  }, []);

  const fmt = (n) => n >= 1_000_000 ? `${(n/1_000_000).toFixed(1)}M` : n >= 1000 ? `${(n/1000).toFixed(0)}K` : n;

  return (
    <Layout>
      <section className="relative py-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <span className="label-gold">Module 04 · Reach</span>
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter text-white mt-3 mb-3">
            Social <span className="gold-shimmer">Command</span>.
          </h1>
          <p className="text-white/60 max-w-2xl">
            Unified TikTok + Instagram feed. Each post anchors a shoppable <span className="text-[#C9A227] font-bold">Signal Link</span> back to the storefront.
          </p>

          <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 mt-14 [&>*]:mb-5">
            {posts.map((p) => {
              const linked = products[p.signal_link];
              return (
                <div key={p.id} className="relative break-inside-avoid group border border-[#C9A227]/15 hover:border-[#C9A227]/60 transition-colors overflow-hidden">
                  <img src={p.image} alt="" className="w-full object-cover"/>
                  <div className="absolute top-3 left-3 text-[10px] tracking-[0.3em] uppercase text-[#C9A227] font-bold bg-black/60 backdrop-blur px-2 py-1">
                    {p.platform}
                  </div>
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black via-black/70 to-transparent p-4">
                    <p className="text-white text-sm leading-snug">{p.caption}</p>
                    <div className="flex items-center gap-4 mt-3 text-[11px] text-white/60 tabular-nums">
                      <span className="flex items-center gap-1"><Heart size={12}/>{fmt(p.likes)}</span>
                      <span className="flex items-center gap-1"><Eye size={12}/>{fmt(p.views)}</span>
                    </div>
                    {linked && (
                      <div className="mt-3 glass border border-[#C9A227]/40 px-3 py-2 flex items-center gap-3">
                        <img src={linked.image} alt="" className="w-10 h-10 object-cover"/>
                        <div className="flex-1 min-w-0">
                          <div className="text-[9px] tracking-[0.25em] uppercase text-[#C9A227] font-bold">Signal Link</div>
                          <div className="text-white text-xs font-bold truncate">{linked.name} · ${linked.price.toFixed(0)}</div>
                        </div>
                        <ExternalLink size={14} className="text-[#C9A227]"/>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
}
